function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import * as React from 'react';
import { Dimensions, Platform, StyleSheet, View } from "react-native-web";
import { initialWindowMetrics, SafeAreaFrameContext, SafeAreaInsetsContext, SafeAreaProvider } from 'react-native-safe-area-context';
var _Dimensions$get = Dimensions.get('window'),
  _Dimensions$get$width = _Dimensions$get.width,
  width = _Dimensions$get$width === void 0 ? 0 : _Dimensions$get$width,
  _Dimensions$get$heigh = _Dimensions$get.height,
  height = _Dimensions$get$heigh === void 0 ? 0 : _Dimensions$get$heigh;

// To support SSR on web, we need to have empty insets for initial values
// Otherwise there can be mismatch between SSR and client output
// We also need to specify empty values to support tests environments
var initialMetrics = Platform.OS === 'web' || initialWindowMetrics == null ? {
  frame: {
    x: 0,
    y: 0,
    width: width,
    height: height
  },
  insets: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
} : initialWindowMetrics;
export default function SafeAreaProviderCompat(_ref) {
  var children = _ref.children,
    style = _ref.style;
  var insets = React.useContext(SafeAreaInsetsContext);
  if (insets) {
    // If we already have insets, don't wrap the stack in another safe area provider
    // This avoids an issue with updates at the cost of potentially incorrect values
    // https://github.com/react-navigation/react-navigation/issues/174
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, style]
    }, children);
  }
  if (Platform.OS === 'web') {
    children = /*#__PURE__*/React.createElement(SafeAreaFrameProvider, {
      initialMetrics: initialMetrics
    }, children);
  }
  return /*#__PURE__*/React.createElement(SafeAreaProvider, {
    initialMetrics: initialMetrics,
    style: style
  }, children);
}

// FIXME: On the Web, the safe area frame value doesn't update on resize
// So we workaround this by measuring the frame on resize
var SafeAreaFrameProvider = function SafeAreaFrameProvider(_ref2) {
  var initialMetrics = _ref2.initialMetrics,
    children = _ref2.children;
  var element = React.useRef(null);
  var _React$useState = React.useState(initialMetrics.frame),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    frame = _React$useState2[0],
    setFrame = _React$useState2[1];
  React.useEffect(function () {
    if (element.current == null) {
      return;
    }
    var rect = element.current.getBoundingClientRect();
    setFrame({
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    });
    var timeout;
    var observer = new ResizeObserver(function (entries) {
      var entry = entries[0];
      if (entry) {
        var _entry$contentRect = entry.contentRect,
          x = _entry$contentRect.x,
          y = _entry$contentRect.y,
          _width = _entry$contentRect.width,
          _height = _entry$contentRect.height;

        // Debounce the frame updates to avoid too many updates in a short time
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          setFrame({
            x: x,
            y: y,
            width: _width,
            height: _height
          });
        }, 100);
      }
    });
    observer.observe(element.current);
    return function () {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/React.createElement(SafeAreaFrameContext.Provider, {
    value: frame
  }, /*#__PURE__*/React.createElement("div", {
    ref: element,
    style: _objectSpread(_objectSpread({}, StyleSheet.absoluteFillObject), {}, {
      pointerEvents: 'none',
      visibility: 'hidden'
    })
  }), children);
};
SafeAreaProviderCompat.initialMetrics = initialMetrics;
var styles = StyleSheet.create({
  container: {
    flex: 1
  }
});